import script from "./RecCardTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecCardTitle.vue?vue&type=script&setup=true&lang=ts"

import "./RecCardTitle.vue?vue&type=style&index=0&id=f833320e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f833320e"]])

export default __exports__